import React from 'react';
import classNames from 'classnames';
var css = {
  "avatar": "rui-JG3z9",
  "icon": "rui-1Apoe"
};
import Icon from '../Icon/Icon';
var HEIGHT_DIVIDER = 3;
var ICON_DIVIDER = 4;
var Avatar = function Avatar(_ref) {
  var _ref$diameter = _ref.diameter,
    diameter = _ref$diameter === void 0 ? '30px' : _ref$diameter,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    image = _ref.image,
    icon = _ref.icon,
    onClick = _ref.onClick;
  var figureStyle = Object.assign({
    width: diameter,
    height: diameter,
    backgroundImage: "url(".concat(image, ")")
  }, style);
  var iconStyle = {
    height: parseInt(diameter, 10) / HEIGHT_DIVIDER
  };
  return /*#__PURE__*/React.createElement("figure", {
    className: classNames(css.avatar, className),
    style: figureStyle
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: css.icon,
    style: iconStyle,
    onClick: onClick,
    onKeyPress: onClick,
    tabIndex: 0,
    role: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: parseInt(diameter, 10) / ICON_DIVIDER,
    color: "white"
  })));
};
export default Avatar;